<template>
  <div id="app-container">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
	name: 'AppLayout',
  };
</script>
<style>
</style>